import { __decorate, __metadata } from "tslib";
import { CrudEndpoints, EditorDefinition, Expose, IdItemModel, IsBoolean, IsNumber, IsString, ItemModelDefinition, ItemModelProp, ModelId } from '@core/shared/model';
import { UseRestraints } from '@core/shared/restraints';
import { PaymentReminderTarget } from '../interfaces';
import { PaymentReminderType } from '../interfaces/payment-reminder-type.enum';
import { PaymentReminderRestraints } from "./payment-reminder.restraints";
let PaymentReminderItem = /*#__PURE__*/(() => {
  let PaymentReminderItem = class PaymentReminderItem extends IdItemModel {
    toString() {
      return "Zahlungserinnerung " + (this.targetName || this.targetId);
    }
  };
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: true
  }), IsBoolean(), __metadata("design:type", Boolean)], PaymentReminderItem.prototype, "enabled", void 0);
  __decorate([Expose(), __metadata("design:type", Date)], PaymentReminderItem.prototype, "creationDate", void 0);
  __decorate([Expose(), __metadata("design:type", Date)], PaymentReminderItem.prototype, "updateDate", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: PaymentReminderTarget.company
  }), __metadata("design:type", String)], PaymentReminderItem.prototype, "target", void 0);
  __decorate([Expose()
  // @ItemModelProp({isOptionalCreate:false, isOptionalUpdate:true})
  , IsNumber({}, {
    message: 'Bitte wählen Sie den Empfänger der Aufforderung aus.'
  }), __metadata("design:type", Number)], PaymentReminderItem.prototype, "targetId", void 0);
  __decorate([Expose(), __metadata("design:type", String)], PaymentReminderItem.prototype, "targetName", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: PaymentReminderType.reminder
  }), IsString({
    message: 'Bitte wählen Sie die Art der Aufforderung.'
  }), __metadata("design:type", String)], PaymentReminderItem.prototype, "type", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", String)], PaymentReminderItem.prototype, "message", void 0);
  __decorate([Expose(), __metadata("design:type", Array)], PaymentReminderItem.prototype, "interactions", void 0);
  PaymentReminderItem = __decorate([EditorDefinition({}, {
    allowAllExposed: true,
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    admin: '/admin/payment-reminder/reminders'
  }), ItemModelDefinition({
    texts: {
      item: 'Zahlungserinnerung',
      items: 'Zahlungserinnerungen'
    }
  }), UseRestraints(PaymentReminderRestraints), ModelId("PaymentReminderItem") // autogenerated by generate-model-ids
  ], PaymentReminderItem);
  return PaymentReminderItem;
})();
export { PaymentReminderItem };